import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Projects from "@/components/Projects";
import Services from "@/components/Services";
import OfficeCarousel from "@/components/OfficeCarousel";
import Process from "@/components/Process";
import About from "@/components/About";
import Estimator from "@/components/Estimator";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Presentation from "@/pages/Presentation";

const LandingPage = () => (
  <div className="min-h-screen bg-white text-slate-900">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Projects />
      <Services />
      <OfficeCarousel />
      <Process />
      <About />
      <Estimator />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ anchors: true, duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/presentasjon" element={<Presentation />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" theme="light" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
